import enProfile from './en';
import ruProfile from './ru';

export default {
  en: {
    ...enProfile,
  },
  ru: {
    ...ruProfile,
  },
};
